import axios from '@/axios'

export function getUserFromGithub(data) {
  const url = '/api/github/call'
  return axios.post(url, data)
}

export function getGistContent(data) {
  const url = '/api/cla/get'
  return axios.post(url, data)
}

export function getLinkedItem(data) {
  const url = '/api/cla/getLinkedItem'
  return axios.post(url, data)
}

export function checkCLA(data) {
  const url = '/api/cla/check'
  return axios.post(url, data)
}

export function getLastSignature(data) {
  const url = '/api/cla/getLastSignature'
  return axios.post(url, data)
}

export function getUserEmail() {
  const url = '/api/github/call'
  const data = {
    obj: "users", fun: "getEmails", arg: {}
  }
  return axios.post(url, data)
}

export function agree(data) {
  const url = '/accept'

  return axios.post(url, data)
}

export function getGuestCla(){
  const url = '/api/cla/getDefault '
  return axios.get(url)
}


// WEBPACK FOOTER //
// ./src/api/cla.js